import { Loader2 } from "lucide-react";
import { Outlet } from "react-router";

import { SidebarHeader } from "@/modules/customer-service/components";
import { useFrontContext } from "@/modules/customer-service/hooks";

const SidebarLayout = () => {
  const { isLoading } = useFrontContext();

  return (
    <main className="flex min-h-screen flex-col bg-muted">
      <SidebarHeader />

      {isLoading ? (
        <div className="flex items-center justify-center gap-2 p-8 text-sm text-muted-foreground">
          <Loader2 className="h-4 w-4 animate-spin" />
        </div>
      ) : (
        <Outlet />
      )}
    </main>
  );
};

export { SidebarLayout };
